module.exports = __webpack_public_path__ + "static/media/act-4.1f12a903.mp3";